import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const CentreMasterMappingUpdateSlice = createSlice({
  name: "CentreMasterMappingUpdateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    centreMasterMappingUpdate: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successCentreMasterMappingUpdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterMappingUpdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterMappingUpdate: (state) => {
      state.data = {};
    },
  },
});

export const {
  centreMasterMappingUpdate,
  successCentreMasterMappingUpdate,
  failureCentreMasterMappingUpdate,
  clearCentreMasterMappingUpdate,
} = CentreMasterMappingUpdateSlice.actions;

export default CentreMasterMappingUpdateSlice.reducer;
